import React, { useState, useEffect, useContext } from "react";
import swal from "sweetalert";

// material components
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import makeStyles from '@mui/styles/makeStyles';
import { addDays, subDays } from "date-fns";
import * as Service from "../../services/Service.js";

// react-tabulator
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator, reactFormatter } from "react-tabulator";

import { useQuery } from "@tanstack/react-query";
import * as api from "../../actions/api";

import {
  Typography,
  TextField,
  Card,
  CardContent,
  Select,
  MenuItem,
  FormControl,
  Grid,
  InputLabel,
} from "@mui/material";

import Autocomplete from '@mui/material/Autocomplete';

import { Button } from "reactstrap";

// core components
import AfterLoginNavbar from "components/Navbars/AfterLoginNavbar.js";

// Highcharts component
import Highcharts from "highcharts/highstock";
import "highcharts/modules/exporting.js";
import "highcharts/modules/accessibility.js";

import { getDefaultMonthYear,getARVFacilityList } from "../../services/Common";
import encryptionService from "../../services/encryptionService";
import { useTranslation } from "react-i18next";


import {checkLogin, checkUserPermission,getUserActionPermission} from "../../services/CheckUserAccess";

const ReportPage = (props) => {

  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const lan = localStorage.getItem("LangCode");
  const { t, i18n } = useTranslation();
  const menukey = "lmis-report";
  const FacilityId = localStorage.getItem("FacilityId");
  const YearList = JSON.parse(localStorage.getItem("YearList"));
  const MonthList = JSON.parse(localStorage.getItem("MonthList"));
  //const FacilityList = JSON.parse(localStorage.getItem("FacilityList"));
  /* const FacilityList = getARVFacilityList(); */

  //let All_Facility_label = {id:"0", name: t(DispensingLanguage[lan][menukey]["All Facility"])};
  //let All_Facility_label = {id:"0", name: "All"};
  //const FacilityList = [All_Facility_label].concat(Facility_List); 
  // const MosTypelist = JSON.parse(localStorage.getItem("MosTypelist"));
  //const bFacilitySelected = localStorage.getItem("bFacilitySelected");
 
  const [RedirectLogin, setRedirectLogin] = React.useState(true);
  const [hasUserPermission, setHasUserPermission] = React.useState(false);
  // const checkLogin = () => {
  //   let token = sessionStorage.getItem("token");
  //   if (!token) {
  //     swal({
  //       title: "Oops!",
  //       text: 'token expired. Please login again',
  //       icon: "warning",
  //       buttons: ["No", "Yes"],
  //       dangerMode: true,
  //     }).then((willDelete) => {
  //       if (willDelete) { 
  //         window.location.href = process.env.REACT_APP_BASE_NAME+`/login`;
  //         sessionStorage.clear();
  //       }
  //     });
  //   }
  // };

  if(RedirectLogin){
    setHasUserPermission(checkUserPermission(menukey));// To check user has permission in this page
    checkLogin();
    setRedirectLogin(false);
  }



  
  
            
/* =============Start Department, Zone, Commune, Facility Dipendency=============  */
const bFacilitySelected = localStorage.getItem("bFacilitySelected");
const UserInfo = encryptionService.decryptUserInfo();          
const defaultRegionId = UserInfo == 0 ? 0 : UserInfo[0].RegionId;
const defaultZoneId = UserInfo == 0 ? 0 : UserInfo[0].ZoneId;
const defaultDistrictId = UserInfo == 0 ? 0 : UserInfo[0].DistrictId;

const objAll = { id: "0", name: t(DispensingLanguage[lan][menukey]["All"]) };

const Regionlist = JSON.parse(localStorage.getItem("Regionlist"));
Regionlist.unshift(objAll);
const [currRegionId, setcurrRegionId] = useState(
  defaultRegionId ? defaultRegionId : 0
);
const [chosenValuesRegion, setChosenValuesRegion] = useState(
  defaultRegionId
    ? (Regionlist.find((list) => list.id == defaultRegionId) ?? null)
    : objAll
);

let TempZSList = useState([]);
const [ZoneList, setZoneListLocal] = useState(TempZSList);
//const [currZoneId, setcurrZoneId] = useState(0);
const [currZoneId, setcurrZoneId] = useState(
    defaultZoneId ? defaultZoneId : 0
);
const [chosenValuesZone, setChosenValuesZone] = useState({});

let TempCommuneList = useState([]);
const [CommuneList, setCommuneListLocal] = useState(TempCommuneList);
//const [currCommuneId, setcurrCommuneId] = useState(0);
const [currCommuneId, setcurrCommuneId] = useState(
  defaultDistrictId ? defaultDistrictId : 0
);


const [chosenValuesDistrict, setChosenValuesDistrict] = useState({});

let TempFacilityList = useState([]);
const [FacilityList, setFacilityListLocal] = useState(TempFacilityList);

const [currFacilityId, setcurrFacilityId] = useState(
  FacilityId
);
const [chosenValuesFacility, setChosenValuesFacility] = useState({});

let isFacilityChange = 0;

React.useEffect(() => {
  cZoneList();
}, [currRegionId]);

React.useEffect(() => {
  cCommuneList();
}, [currRegionId, currZoneId]);

React.useEffect(() => {
  cFacilityList();
}, [currRegionId, currZoneId, currCommuneId]);


//====== Start Choosen Dropdown===========

const handleChangeChoosenRegion = (name, valueobj, value) => {

  setChosenValuesRegion(valueobj);
  setcurrRegionId(value);

  setcurrZoneId(0);
  setcurrCommuneId(0);
  //setcurrFacilityId(FacilityList[0].id);

  setChosenValuesZone(objAll);
  setChosenValuesDistrict(objAll);

  isFacilityChange = 0;
  console.log('isFacilityChange set 0: ', isFacilityChange);
  //setChosenValuesFacility({"id": FacilityList[0].id,"name": FacilityList[0].name});
};

const handleChangeChoosenZone = (name, valueobj, value) => {

  setChosenValuesZone(valueobj);
  setcurrZoneId(value);
  setcurrCommuneId(0);
   //setcurrFacilityId(FacilityList[0].id);

  setChosenValuesDistrict(objAll);
  isFacilityChange = 0;
  console.log('isFacilityChange set 0: ', isFacilityChange);
  //setChosenValuesFacility({"id": FacilityList[0].id,"name": FacilityList[0].name});
};

const handleChangeChoosenDistrict = (name, valueobj, value) => {

  setChosenValuesDistrict(valueobj);
  //setLoading(false);
  setcurrCommuneId(value);
  isFacilityChange = 0;
  console.log('isFacilityChange set 0: ', isFacilityChange);

  // setcurrFacilityId(FacilityList[0].id);
  //setChosenValuesFacility({"id": FacilityList[0].id,"name": FacilityList[0].name});
};

const handleChangeChoosenFacility = (name, valueobj, value) => {
  setChosenValuesFacility(valueobj);

  setcurrFacilityId(value);
};

//====== End Choosen Dropdown===========

const cZoneList = () => {
  let ZoneListParam = {
    action: "Zonelist",
    RegionId: currRegionId,
    FacilityId: FacilityId,
    menukey: "",
  };

  Service.default
    .postApi("source/combo_generic.php", ZoneListParam)
    .then((res) => {
      let All_Zone_label = objAll;
      const Zone_List = [All_Zone_label].concat(res.datalist);
      setZoneListLocal(Zone_List);

      let defaultZone =
        (Zone_List.find((list) => list.id == currZoneId) ?? null);
      setChosenValuesZone(defaultZone);
    })
    .catch((err) => {});
};

const cCommuneList = () => {
  let CommuneListParam = {
    action: "Communelist",
    RegionId: currRegionId,
    ZoneId: currZoneId,
    FacilityId: FacilityId,
    menukey: "",
  };

  Service.default
    .postApi("source/combo_generic.php", CommuneListParam)
    .then((res) => {
      let All_Commune_label = objAll;
      const Commune_List = [All_Commune_label].concat(res.datalist);
      setCommuneListLocal(Commune_List);

      let defaultCommune =
        (Commune_List.find((list) => list.id == currCommuneId) ?? null);
      setChosenValuesDistrict(defaultCommune);
    })
    .catch((err) => {});
};

const cFacilityList = () => {
  let FacilityListParam = {
    action: "ARVFacilityListByDepartmentZoneCommune",
    RegionId: currRegionId,
    ZoneId: currZoneId,
    DistrictId: currCommuneId,
    menukey: "",
  };

  Service.default
    .postApi("source/combo_generic.php", FacilityListParam)
    .then((res) => {

      isFacilityChange = 1;
      console.log('isFacilityChange set 1: ', isFacilityChange);

      const Facility_List = res.datalist;
     

     let defaultFacility =
        (Facility_List.find(
            (facilitylist) => facilitylist.id == currFacilityId
          ) ?? null); 

        

        /* setChosenValuesFacility({"id": res.datalist[0].id,"name": res.datalist[0].name});  */
         //setcurrFacilityId(currFacilityId);
         setcurrFacilityId(defaultFacility?currFacilityId:res.datalist[0].id);
         //setChosenValuesFacility(defaultFacility); 
         setChosenValuesFacility(defaultFacility?defaultFacility:{"id": res.datalist[0].id,"name": res.datalist[0].name}); 

        setFacilityListLocal(Facility_List);
        
    })
    .catch((err) => {});
};

/* =============End Department, Zone, Commune, Facility Dipendency=============  */
 



  const classes = useStyles();

  const [pickerData, setPickerData] = useState([{
      startDate: subDays(new Date(), 29),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const [isLoadingDashboard, setLoading] = useState(true);

  const [currYearId, setCurrYearId] = useState(
    getDefaultMonthYear().defaultYear
  );
  const [currMonthId, setCurrMonthId] = useState(
    getDefaultMonthYear().defaultMonthId
  );


  const handleYearChange = (event) => {
    setCurrYearId(event.target.value);
  };

  const handleMonthChange = (event) => {
    setCurrMonthId(event.target.value);
  };


  const [nationalStockCategory, setNationalStockCategory] = useState([]);
  const [nationalStockData, setNationalStockData] = useState([]);
  const [nationalStockDateRange, setnationalStockDateRange] = useState([]);
/*   const bFacilitySelected = localStorage.getItem("bFacilitySelected");
  const [currFacilityId, setCurrFacilityId] = useState(FacilityId);
  */

 /*  const handleFacilityChange = (event, newValue) => {
    let rowId = '';
    if(newValue == null){
      rowId = '';
    }else{
      rowId = newValue.id;
    }

    setCurrFacilityId(rowId);
 };
 */


  let params1 = {
    action: "getLMISReportTable",
    menukey: menukey,
    RegionId: currRegionId,
    ZoneId: currZoneId,
    CommuneId: currCommuneId,
    FacilityId: currFacilityId,
    Month: currMonthId,
    Year: currYearId,
  };
  const [dataItems, setDataItems] = useState([]);
  const { refetch } = useQuery([params1], api.getLMISReportTable, {
    onSuccess: (data) => {
      setDataItems(data);
	},
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 0,//1000 * 60 * 60 * 24,
  });

  useEffect(() => {
    if (currYearId > 0 && currMonthId > 0) {
      // getConsumptionTrendsTopFiveProducts.refetch();
    }
  }, [currYearId, currMonthId, currRegionId, currZoneId, currCommuneId, currFacilityId]);




  React.useEffect(() => {
    // checkLogin();
  }, []);

  const handleDatePicker = (e) => {};

  const columns = [
   /*  {
      title: t(DispensingLanguage[lan][menukey]["Sl#."]),
      formatter: "rownum",
      width: 40,
      hozAlign: "center",
      headerSort: false,
      headerHozAlign: "center",
    }, */
  {
      title: t(DispensingLanguage[lan][menukey]["Product Code"]),
      field: "ItemCode",
      width: 120,
      headerFilter: true,
    }, 
    {
      title: t(DispensingLanguage[lan][menukey]["Designation"]),
      field: "ItemName",
      //width: 250,
      headerFilter: true,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Unit"]),
      field: "UnitName",
      headerFilter: true,
      width: 85,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Opening Stock"]),
      field: "OpB",
      width: 100,
      hozAlign: "right",
      headerHozAlign: "right",
      formatter: "money",
      formatterParams:{ thousand:",",  precision:false }
    },

  //Mouvements du mois group column start

      {
        title: t(DispensingLanguage[lan][menukey]["Mouvements du mois"]),
        hozAlign: "center",
        headerHozAlign: "center",
            columns:[
                  {
              title: t(DispensingLanguage[lan][menukey]["Receive"]),
              field: "RecB",
              hozAlign: "right",
              headerHozAlign: "right",
              headerFilter: false,
              width: "100",
    
            },
            {
              title: t(DispensingLanguage[lan][menukey]["Quantity Dispensed"]),
              field: "Consumption",
              hozAlign: "right",
              headerHozAlign: "right",
              headerFilter: false,
              width: "100",
            
    
            },
    
            {
              title: t(DispensingLanguage[lan][menukey]["Adjustment"]),
              field: "AdjB",
              hozAlign: "right",
              headerHozAlign: "right",
              headerFilter: false,
              width: "100",
              formatter: function (cell, formatterParams) {
              let value = cell.getValue();
              return value == 0 ? "" : value;
              },
    
            },   
      
      
            ],
        },
  //Mouvements du mois group column end

      {
        title: t(DispensingLanguage[lan][menukey]["Closing Balance"]),
        field: "Stock",
        width: 95,
        hozAlign: "right",
        headerHozAlign: "right",
        formatter: "money",
        formatterParams:{ thousand:",",  precision:false }
      },

      {
        title: t(DispensingLanguage[lan][menukey]["AMC"]),
        field: "AMC",
        width: 75,
        hozAlign: "right",
        headerHozAlign: "right",
        formatter: "money",
        formatterParams:{ thousand:",",  precision:false }
      },
      {
        title: t(DispensingLanguage[lan][menukey]["Stock minimum"]),
        field: "StockMin",
        width: 100,
        hozAlign: "right",
        headerHozAlign: "right",
        formatter: function (cell, formatterParams) {
          let value = cell.getValue();
          return value == 0 ? "" : value;
        },
      },
      {
        title: t(DispensingLanguage[lan][menukey]["Stock maximum"]),
        field: "StockMax",
        width: 100,
        hozAlign: "right",
        headerHozAlign: "right",
        formatter: function (cell, formatterParams) {
          let value = cell.getValue();
          return value == 0 ? "" : value;
        },
      },
      {
        title: t(DispensingLanguage[lan][menukey]["Stockout Days"]),
        field: "StockoutDays",
        width: 100,
        hozAlign: "right",
        headerHozAlign: "right",
        formatter: function (cell, formatterParams) {
          let value = cell.getValue();
          return value == 0 ? "" : value;
        },
      },

      {
        title: t(DispensingLanguage[lan][menukey]["MOS"]),
        field: "MOS",
        width: 75,
        hozAlign: "right",
        headerHozAlign: "right",
        //formatter: "money",
        //formatterParams:{ thousand:",",  precision:false }

        formatter:function(cell, formatterParams){
            var value = cell.getValue();
            if (value || (value == 0)) {
                return value.toFixed(1) ;
            }else{
              return "";
            }
        },

      },
  ];

  /* =====Start of Excel Export Code==== */
  const EXCEL_EXPORT_URL = process.env.REACT_APP_API_URL;

  const PrintPDFExcelExportFunction = (reportType) => {
    let finalUrl = EXCEL_EXPORT_URL + "report/print_pdf_excel_server.php";
    let currFacilityName = (FacilityList.find((Facility_List) => Facility_List.id == currFacilityId) ?? null).name;
    let currDepartmentName = (Regionlist.find((List) => List.id == currRegionId) ?? null).name;
    let currZoneName = (ZoneList.find((List) => List.id == currZoneId) ?? null).name;
    let currCommuneName = (CommuneList.find((List) => List.id == currCommuneId) ?? null).name;



    window.open(
      finalUrl +
        "?action=LMISReportExcelExport" +
        "&reportType=" +
        reportType +
        "&menukey=" +
        menukey +
        "&lan=" +
        localStorage.getItem("LangCode") + 
        "&TimeStamp=" + Date.now() + 
        "&Month=" + currMonthId +
        "&Year=" + currYearId +
        "&RegionId=" + currRegionId +
        "&ZoneId=" + currZoneId +
        "&CommuneId=" + currCommuneId +
        "&FacilityId=" + currFacilityId +
        "&FacilityName=" + currFacilityName +
        "&DepartmentName=" + currDepartmentName +
        "&ZoneName=" + currZoneName +
        "&CommuneName=" + currCommuneName 
    );
  };
  /* =====End of Excel Export Code==== */

  return (
    hasUserPermission && (
    <>
      <AfterLoginNavbar {...props} />

      <div
        className="section signup-top-padding"
        style={{
          backgroundImage: "url(" + require("assets/img/bg8.jpg") + ")",
          backgroundSize: "cover",
          backgroundPosition: "top center",
          minHeight: "753px",
        }}
      >
        <div className="dashboard-pannel">
          <div className="d-flex justify-product mb-1">
            <div className="sw_page_heading">
              <div className="sw_heading_title">
                {t(DispensingLanguage[lan][menukey]["LMIS Report"])}
              </div>
            </div>
          </div>

          {/* start of filter */}
          <Card className="sw_card sw_filter_card">
            <CardContent className="sw_filterCardContent">
              <Grid container spacing={1}>
                <Grid item xs={1} sm={1}>
                  <FormControl variant="standard" className={classes.fullWidth}>
                  <InputLabel id="demo-simple-select-helper-label">
                        {DispensingLanguage[lan][menukey]["Year"]}
                      </InputLabel>
                    <Select
                      labelId="demo-simple-select-helper-label"
                      id="YearList"
                      name="YearList"
                      value={currYearId}
                      onChange={handleYearChange}
                      fullWidth
                    label={DispensingLanguage[lan][menukey]["Year"]}>
                      {YearList.map((item, index) => {
                        return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={1} sm={1}>
                  <FormControl variant="standard" className={classes.fullWidth}>
                  <InputLabel id="demo-simple-select-helper-label">
                        {DispensingLanguage[lan][menukey]["Month"]}
                      </InputLabel>
                    <Select
                      labelId="demo-simple-select-helper-label"
                      id="MonthList"
                      name="MonthList"
                      value={currMonthId}
                      onChange={handleMonthChange}
                      fullWidth
                    label={DispensingLanguage[lan][menukey]["Month"]}>
                      {MonthList.map((item, index) => {
                        return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                </Grid>


                <Grid item xs={2} sm={2}>
                        <FormControl className={classes.fullWidth}>
                          <Autocomplete
                            autoHighlight
                            disableClearable
                            id="RegionId"
                            options={Regionlist}
                            onChange={(event, valueobj) =>
                              handleChangeChoosenRegion(
                                "RegionId",
                                valueobj,
                                valueobj ? valueobj.id : ""
                              )
                            }
                            getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                            value={chosenValuesRegion}
                            renderOption={(props, option) => (
                              <li {...props} key={option.id ?? option.name}>
                                <Typography className="sw_fontSize">{option.name}</Typography>
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={
                                  DispensingLanguage[lan][menukey]["Department"]
                                }
                                variant="standard"
                                id="RegionId"
                                name="RegionId"
                                fullWidth
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={2} sm={2}>
                        <FormControl className={classes.fullWidth}>
                          <Autocomplete
                            autoHighlight
                            disableClearable
                            id="ZoneId"
                            options={ZoneList}
                            onChange={(event, valueobj) =>
                              handleChangeChoosenZone(
                                "ZoneId",
                                valueobj,
                                valueobj ? valueobj.id : ""
                              )
                            }
                            getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                            value={chosenValuesZone}
                            renderOption={(props, option) => (
                              <li {...props} key={option.id ?? option.name}>
                                <Typography className="sw_fontSize">{option.name}</Typography>
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={DispensingLanguage[lan][menukey]["ZS"]}
                                variant="standard"
                                id="ZoneId"
                                name="ZoneId"
                                fullWidth
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={2} sm={2}>
                        <FormControl className={classes.fullWidth}>
                          <Autocomplete
                            autoHighlight
                            disableClearable
                            id="DistrictId"
                            options={CommuneList}
                            onChange={(event, valueobj) =>
                              handleChangeChoosenDistrict(
                                "DistrictId",
                                valueobj,
                                valueobj ? valueobj.id : ""
                              )
                            }
                            getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                            value={chosenValuesDistrict}
                            renderOption={(props, option) => (
                              <li {...props} key={option.id ?? option.name}>
                                <Typography className="sw_fontSize">{option.name}</Typography>
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={DispensingLanguage[lan][menukey]["Commune"]}
                                variant="standard"
                                id="DistrictId"
                                name="DistrictId"
                                fullWidth
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={3} sm={3}>
                        <FormControl className={classes.fullWidth}>
                          <Autocomplete
                            autoHighlight
                            disableClearable
                            id="FacilityId"
                            options={FacilityList}
                            onChange={(event, valueobj) =>
                              handleChangeChoosenFacility(
                                "FacilityId",
                                valueobj,
                                valueobj ? valueobj.id : ""
                              )
                            }
                            getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                            value={chosenValuesFacility}
                            renderOption={(props, option) => (
                              <li {...props} key={option.id ?? option.name}>
                                <Typography className="sw_fontSize">{option.name}</Typography>
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={DispensingLanguage[lan][menukey]["Facility"]}
                                variant="standard"
                                id="FacilityId"
                                name="FacilityId"
                                fullWidth
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>

                {/* <Grid item xs={3} sm={3}>
                  <FormControl className={classes.fullWidth}>
                    
                    <Autocomplete
                      autoHighlight
                      className="sw_chosen_filter"
                      id="FacilityList"
                      disableClearable
                      options={FacilityList}
                      onChange={(event, newValue) => handleFacilityChange(event, newValue)}
                      getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                      defaultValue={FacilityList[FacilityList.findIndex(facilitylist => facilitylist.id == currFacilityId)]}
                      renderOption={(props, option) => (
                        <li {...props} key={option.id ?? option.name}>
                          <Typography className="sw_fontSize">{option.name}</Typography>
                        </li>
                      )}
                      
                      renderInput={(params) => (
                      <TextField
                        {...params}
                        // label={DispensingLanguage[lan][menukey]["All Facility"]}
                        variant="standard"
                        hiddenLabel
                      />
                      )}
                    />

                  </FormControl>
                </Grid> */}

                <Grid item xs={1} sm={1}>

                    <div className="float-end sw_btn_control">
                    <Button
                      color="info"
                      className="me-2 sw_icons"
                      onClick={() => PrintPDFExcelExportFunction("print")}
                    >
                      <i className="fas fa-print"></i>
                    </Button>

                    <Button
                      color="info"
                      className="me-2 sw_icons"
                      onClick={() => PrintPDFExcelExportFunction("excel")}
                    >
                      <i className="far fa-file-excel"></i>
                    </Button>
                  </div>
              


                </Grid>
              </Grid>
            </CardContent>
          </Card>
          {/* end of filter */}

          {/* new row */}
          <div className="row">
            <div className="col-md-12">
              <Card className="sw_card">
               {/*  <CardHeader
                  
                /> */}

                <CardContent>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="uniqueName">
                        <ReactTabulator
                          columns={columns}
                          data={dataItems}
                          layout={"fitColumns"}
                          height="600px"
                          options={{
                            //groupBy: ["GroupName", "ItemName"],
                            groupBy: "GroupName",
                            columnCalcs: "both",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
          {/* end row */}
        </div>
      </div>
    </>)
  );
};

export default ReportPage;

const useStyles = makeStyles({
  root: {
    width: "20%",
    margin: "0 1rem",
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  cardDiv: {
    display: "flex",
  },
  fullWidth: {
    width: "100%",
  },
});
